import { render, staticRenderFns } from "./EwalletView.vue?vue&type=template&id=7b4ad578&"
import script from "./EwalletView.vue?vue&type=script&lang=js&"
export * from "./EwalletView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports